// extracted by mini-css-extract-plugin
module.exports = {"backImage":"auth_backImage__1_4Nq","overlay":"auth_overlay__fnMkm","center":"auth_center__3tgzh","actionButton":"auth_actionButton__1fCxd","loginLogo":"auth_loginLogo__325Pg"};